import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/File";

export const Get = (options) => GENERATE_URL(`${PREFIX_URL}/GetFile`, options);

export const GetReceipt = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetReceipt`, options);

export default {
  Get,
  GetReceipt,
};
